'use strict';

var _slicedToArray = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var table = require('./base-table.json'); // map for codecConstant -> code


var constants = {};

for (var _i = 0, _Object$entries = Object.entries(table); _i < _Object$entries.length; _i++) {
  var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      name = _Object$entries$_i[0],
      code = _Object$entries$_i[1];

  constants[name.toUpperCase().replace(/-/g, '_')] = code;
}

module.exports = Object.freeze(constants);